<div class="flex h-full flex-col" data-test="file-tree">
  <!-- <exam-asset-tree-toolbar /> -->
  <exam-asset-tree class="flex flex-1 flex-col" />
</div>
